import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { loadingSelector , headerSelector} from '../../selectors/layoutSelector'
import { instalacionSelector, usuarioSelector, resultadoAutenticacionSelector } from '../../selectors/sessionSelector'
import * as layoutActions from '../../reducers/layoutReducer/actions'
import * as sessionActions from '../../reducers/sessionReducer/actions'
import Layout from '../../components/Layout'

class LayoutContainer extends React.Component {

    constructor(props) {
        super(props)

        this.state = {
            drawerOpen: false,
            
            //cargandoInstalacion: true,
        }
        
        // verifico si la instalación está identificada
        if(this.props.instalacion.datosContacto === undefined) {
            
            // busco la configuración de la instalación            
            let url = encodeURIComponent(window.location.href)
            this.props.sagaFetchInstalacion(url)
        }

        //verifico si el usuario está logueado
        if(this.props.usuario === undefined) {
            
                      
            this.props.sagaFetchUsuarioLogeado();
        }
        
    }

    /*componentDidUpdate = () => {
        if(this.state.cargandoInstalacion === true && this.props.instalacion !== undefined) {
            this.setState({ 
                cargandoInstalacion: false
            })
        }
    }*/

    handleDrawerOpen = () => {
        this.setState({ drawerOpen: true });
    };
    
    handleDrawerClose = () => {
        this.setState({ drawerOpen: false });
    };

    
    handleCerrarSession = () => {
    
    //Si no tiene un pedido en borrador cierro session y redirecciono al Login, si no pregunto si quiere seguir con el pedido
   
      
      //cierro session
      this.props.sagaLogOutUsuario()

      //Limpio los reductores
      //catalogo
  
      
      //session
      this.props.initializeFormSession()

      
      //Redirecciono al login
      window.location.hash = `/Login`
 

  }
    render() {

        return (
            <div>   
                {/*!this.state.cargandoInstalacion && 
                    <Layout 
                        drawerOpen={this.state.drawerOpen}
                        handleDrawerOpen={this.handleDrawerOpen}
                        handleDrawerClose={this.handleDrawerClose}
                        loading={this.props.loading}
                        header={this.props.header}
                    />
                */}
                <Layout 
                  instalacion={this.props.instalacion}
                        drawerOpen={this.state.drawerOpen}
                        usuario={this.props.usuario}
                        handleDrawerOpen={this.handleDrawerOpen}
                        handleDrawerClose={this.handleDrawerClose}
                        handleCerrarSession={this.handleCerrarSession}
                        loading={this.props.loading}
                        header={this.props.header}
                    />
            </div>
        )
    }
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators({
        ...layoutActions,
        ...sessionActions,
	}, dispatch)
}

function mapStateToProps(state) {
    
	return {
        usuario: usuarioSelector(state),
        instalacion: instalacionSelector(state),
        loading: loadingSelector(state),
        header: headerSelector(state),
        resultadoAutenticacion:resultadoAutenticacionSelector(state),
	}
}



export default connect(mapStateToProps, mapDispatchToProps)(LayoutContainer)